// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"952c98f0","220":"de8887c4","231":"cbf83479","262":"bf1cd282","372":"17ebf006","417":"fc195d18","450":"3ff1fec0","453":"02a55c4f","705":"4f8ac92b","768":"7038887d","821":"a28686d1","874":"371d80d3"}[chunkId] + ".chunk.js";
};